// axiosInstance.js
import axios from "axios";
import config from "../config";
import { toast } from "react-toastify";

const omsAxiosInstance = axios.create({
  baseURL: config.omsUrl,
  timeout: 1000 * 60 * 10,
});

omsAxiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("rl_oms_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    if (config.data instanceof FormData) {
      config.headers["Content-Type"] = "multipart/form-data";
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Response interceptor to handle 401 Unauthorized errors
omsAxiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.code === "ERR_NETWORK") {
      return;
    }
    const status = error.response ? error.response.status : null;

    if (status === 401) {
      // Handle unauthorized access
      console.log("Unauthorized access", error);
      toast.error(error?.response?.data?.message);
      localStorage.clear();
      if (window?.location?.pathname !== "/login") {
        window.location.href = "/login";
      }
    } else {
      if (error.message !== "canceled") {
        toast.error(error?.response?.data?.message || "An error occurred");
      }

      // console.error("An error occurred:", error);
    }

    return Promise.reject(error);
  },
);
// Utility function to handle unauthorized access

export default omsAxiosInstance;
